import { Checkbox, Space, Tag } from 'antd';
import styles from './RequirementItem.module.less';

interface Props {
	id: number;
	checked: boolean;
	index: number;
	description: string;
	prefix: string;
	onChange: (index: number, checked: boolean) => void;
}

export default function RequirementItem(props: Props) {
	const { id, checked, index, description, prefix, onChange } = props;
	return (
		<div>
			<Space size={[8, 16]} wrap className={styles.item}>
				<Checkbox
					defaultChecked={checked}
					onChange={(e) => {
						onChange(id, e.target.checked);
					}}
				/>
				<span className={styles.index}>{`${index}.`}</span>
				{prefix && <Tag color="default">{prefix}</Tag>}
				<span>{description}</span>
			</Space>
		</div>
	);
}
